export default __webpack_public_path__ + "static/media/sl.960d24e4.svg";